<template>
  <v-dialog
    v-model="dialogCreatePackage"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>
          {{isChinessLanguage ? '创建包裹' : 'Tạo bao hàng'}} - {{ currentItem.TransactionCode }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg12 md12 sm12>
            <v-list-item>
              <v-list-item-content>
                <span class="grey--text">{{ isChinessLanguage ? '商品数量' : 'Số kiện hàng' }}:</span>
                <span class="font-weight-bold">{{ currentItem.RealNumberOfPack }}</span>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-divider></v-divider>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <span class="font-weight-bold">{{ isChinessLanguage ? '包裹信息' : 'Thông tin bao hàng' }}</span>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-text-field
              v-model="commonPackageNote"
              :label="isChinessLanguage ? '笔记（所有子包共用）' : 'Ghi chú (dùng chung cho tất cả bao con)'"
              dense
              outlined
            ></v-text-field>
            <div class="grey--text text--darken-1 mt-1">
              {{ helperText }}
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closePopup">
          {{ isChinessLanguage ? '取消' : 'Hủy' }}
        </v-btn>
        <v-btn
          color="primary"
          @click="createPackages"
          :loading="isLoading"
          :disabled="totalPack === 0"
        >
          {{ isChinessLanguage ? '创建' : 'Tạo' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";

export default {
  props: ["dialogCreatePackage", "currentItem"],
  data() {
    return {
      commonPackageNote: "",
      isLoading: false
    };
  },
  computed: {
    ...mapState({
      isChinessLanguage: state =>
        (state.authentication.user.roletype &
          configs.ROLE_TYPE.StoreTQ) ==
          configs.ROLE_TYPE.StoreTQ &&
        state.authentication.user.ischinesslanguage
    }),
    childPackages() {
      try {
        const packages = this.currentItem && this.currentItem.Packages
          ? JSON.parse(this.currentItem.Packages)
          : [];
        return Array.isArray(packages) ? packages : [];
      } catch (error) {
        return [];
      }
    },
    hasChildPackages() {
      return this.childPackages.length > 0;
    },
    totalPack() {
      return Number(this.currentItem.RealNumberOfPack || 0);
    },
    helperText() {
      if (this.hasChildPackages) {
        return this.isChinessLanguage
          ? `系统将根据现有子包创建 ${this.childPackages.length} 个包裹`
          : `Hệ thống sẽ tạo ${this.childPackages.length} bao theo các mã con hiện có`;
      }
      return this.isChinessLanguage
        ? '系统将创建 1 个包裹并直接绑定 mã vận đơn cha'
        : 'Hệ thống sẽ tạo 1 bao và gắn trực tiếp mã vận đơn cha';
    }
  },
  methods: {
    createPackages() {
      if (this.totalPack <= 0) {
        sendErrorNotice(
          this.isChinessLanguage ? "请至少添加一个包裹" : "Vui lòng thêm ít nhất 1 bao"
        );
        return;
      }

      this.isLoading = true;
      const parentCode = this.currentItem.TransactionCode || '';

      if (!this.hasChildPackages) {
        this.$store
          .dispatch("bigPackage/setDetail", {
            data: {
              PackageCode: this.commonPackageNote || parentCode,
              ProductType: this.currentItem.ProductType || 5,
              ReceivePlaceID: 1,
              NumberOfPack: this.totalPack || 1,
              Weight: this.currentItem.ChinaWeight || 0,
              Volume: this.totalPack || 1,
              Amount: this.currentItem.ChinaFeeShip || 0,
              Packages: [this.currentItem.ID]
            },
            id: Number(this.currentItem.BigPackageID || 0),
            silent: true
          })
          .then(res => {
            const createdBigPackageId = Number(this.currentItem.BigPackageID || 0)
              || (((res || {}).data || {}).ID || 0);

            return this.$store.dispatch("orderTransaction/setDetail", {
              data: {
                BigPackageID: createdBigPackageId
              },
              id: this.currentItem.ID
            });
          })
          .then(() => {
            this.isLoading = false;
            sendSuccessNotice(
              this.isChinessLanguage
                ? "包裹创建成功"
                : "Tạo bao hàng thành công"
            );
            this.closePopup();
            this.$root.$emit("REQUEST_REFRESH_DATA");
          })
          .catch(error => {
            this.isLoading = false;
            sendErrorNotice(
              this.isChinessLanguage
                ? "创建包裹失败: " + (error.message || "")
                : "Lỗi tạo bao hàng: " + (error.message || "")
            );
          });
        return;
      }

      const childWeight = this.currentItem.ChinaWeight
        ? Number(this.currentItem.ChinaWeight) / this.childPackages.length
        : 0;
      const childAmount = this.currentItem.ChinaFeeShip
        ? Number(this.currentItem.ChinaFeeShip) / this.childPackages.length
        : 0;

      this.childPackages
        .reduce((promise, childPackage) => {
          const childCode = childPackage.TransactionCode || parentCode;
          return promise.then(results =>
            this.$store
              .dispatch("bigPackage/setDetail", {
                data: {
                  PackageCode: this.commonPackageNote || childCode,
                  ProductType: this.currentItem.ProductType || 5,
                  ReceivePlaceID: 1,
                  NumberOfPack: 1,
                  Weight: childWeight,
                  Volume: 1,
                  Amount: childAmount,
                  Packages: []
                },
                id: 0,
                silent: true
              })
              .then(res => results.concat([res]))
          );
        }, Promise.resolve([]))
        .then(results => {
          const createdBigPackageIds = results.map(
            res => (((res || {}).data || {}).ID || 0)
          );

          const generatedPackages = this.childPackages.map((childPackage, index) => ({
            ...childPackage,
            TransactionCode: childPackage.TransactionCode || parentCode,
            BigPackageID: createdBigPackageIds[index] || null,
            PackageNote: this.commonPackageNote || childPackage.PackageNote || null
          }));

          return this.$store.dispatch("orderTransaction/setDetail", {
            data: {
              Packages: JSON.stringify(generatedPackages),
              BigPackageID: 0
            },
            id: this.currentItem.ID
          });
        })
        .then(() => {
          this.isLoading = false;
          sendSuccessNotice(
            this.isChinessLanguage
              ? "包裹创建成功"
              : "Tạo bao hàng thành công"
          );
          this.closePopup();
          this.$root.$emit("REQUEST_REFRESH_DATA");
        })
        .catch(error => {
          this.isLoading = false;
          sendErrorNotice(
            this.isChinessLanguage
              ? "创建包裹失败: " + (error.message || "")
              : "Lỗi tạo bao hàng: " + (error.message || "")
          );
        });
    },
    closePopup() {
      this.commonPackageNote = "";
      this.$emit("closePopup");
    }
  },
  watch: {
    dialogCreatePackage(val) {
      if (!val) {
        this.commonPackageNote = "";
      }
    }
  }
};
</script>

<style scoped>
</style>
